import { mapState, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('guideBoardStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('guideBoardStore', Object.keys(actions)),
	...mapMutations('guideBoardStore', Object.keys(mutations))
};
